import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.stocks;
export const stocksRoute = {
    path: rootPath,
    // `Warehouse` role (Warehouse manager) should have access to Stock section only in Warehouse, not Admin!
    // element: <ProtectedRoute allow={'Warehouse'} />,
    element: _jsx(ProtectedRoute, { claims: claimIds }),
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
    children: [
        {
            index: true,
            lazy: async () => {
                const { Stocks } = await import('@/admin/modules/stocks/StockList');
                return { Component: Stocks };
            },
        },
        {
            path: ':stockId',
            lazy: async () => {
                const { StockDetailsContainer } = await import('@/admin/modules/stock/components/StockDetailsContainer');
                return { Component: StockDetailsContainer };
            },
            handle: {
                crumb: ({ params }) => _jsx(NavLink, { to: `${linkTo}/${params.stockId}`, children: t('stock.label') }),
            },
        },
    ],
};
